import { render, staticRenderFns } from "./normalQRCode.vue?vue&type=template&id=58cd22c0&scoped=true&"
import script from "./normalQRCode.vue?vue&type=script&lang=js&"
export * from "./normalQRCode.vue?vue&type=script&lang=js&"
import style0 from "./normalQRCode.vue?vue&type=style&index=0&id=58cd22c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cd22c0",
  null
  
)

export default component.exports